import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

import type { RootState } from '../index'

export interface SoapTemplateConfigState {
  defaultDischargeNotesTemplateId: string | null
  defaultMedicalNotesTemplateId: string | null
}

export const soapTemplateConfigInitialState: SoapTemplateConfigState = {
  defaultMedicalNotesTemplateId: null,
  defaultDischargeNotesTemplateId: null,
}

const soapTemplateConfigSlice = createSlice({
  name: 'soapTemplateConfig',
  initialState: soapTemplateConfigInitialState,
  reducers: {
    setDefaultMedicalNotesTemplateId: (
      state,
      action: PayloadAction<string | null>,
    ) => {
      state.defaultMedicalNotesTemplateId = action.payload
    },
    setDefaultDischargeNotesTemplateId: (
      state,
      action: PayloadAction<string | null>,
    ) => {
      state.defaultDischargeNotesTemplateId = action.payload
    },
    resetSoapTemplateConfig: (state) => {
      state.defaultMedicalNotesTemplateId = null
      state.defaultDischargeNotesTemplateId = null
    },
  },
})

export const {
  setDefaultMedicalNotesTemplateId,
  setDefaultDischargeNotesTemplateId,
  resetSoapTemplateConfig,
} = soapTemplateConfigSlice.actions

export default soapTemplateConfigSlice.reducer

const getSoapTemplateConfig = (state: RootState): SoapTemplateConfigState =>
  state.soapTemplateConfig
export const getDefaultMedicalNotesTemplateId = (state: RootState) =>
  getSoapTemplateConfig(state).defaultMedicalNotesTemplateId
export const getDefaultDischargeNotesTemplateId = (state: RootState) =>
  getSoapTemplateConfig(state).defaultDischargeNotesTemplateId
